import moment from "moment";

const state = {
  filters: {
    business: null,
    location: null,
    warehouse: null,
    project: null,
    department_id: null,
    accountBank: null,
    payments_id: null,
    dateStart: moment().startOf("month").format("YYYY-MM-DD"),
    dateEnd: moment().endOf("month").format("YYYY-MM-DD"),
    isNewOrder: false,
    isPackage: false,
    isDelivery: false
  },
  rangeSelected: "4", // Valor por defecto: "Este mes"
  date: moment().startOf("month").format("YYYY-MM-DD"),
  date2: moment().endOf("month").format("YYYY-MM-DD"),
  _isInitialized: false, // Flag para tracking de inicialización
  //filtros para usar con url
  invoiceSalesFilters: {
    currency: 0,
    customer: 0,
    branch: 0,
    box: 0,
    invoice_type: 0,
    invoice_category: 0
    // Añadir aquí cualquier otro filtro de UI que maneje InvoiceView
  }
};

const getters = {
  filters: state => state.filters,
  invoiceSalesFilters: state => state.invoiceSalesFilters,
  dateRange: state => ({
    start: state.date,
    end: state.date2,
    startFormatted: moment(state.date).format("DD/MM/YYYY"),
    endFormatted: moment(state.date2).format("DD/MM/YYYY")
  }),

  // Getter para obtener los filtros completos con fechas sincronizadas
  completeFilters: state => ({
    ...state.filters,
    dateStart: state.date,
    dateEnd: state.date2,
    rangeSelected: state.rangeSelected
  }),

  // Getter para debug
  debugState: state => ({
    filters: state.filters,
    date: state.date,
    date2: state.date2,
    rangeSelected: state.rangeSelected,
    isInitialized: state._isInitialized
  })
};

const actions = {
  // Action para inicializar fechas de forma segura
  initializeDates({ commit, state }) {
    if (!state._isInitialized) {
      const currentStart = moment().startOf("month").format("YYYY-MM-DD");
      const currentEnd = moment().endOf("month").format("YYYY-MM-DD");

      commit('setDateRange', {
        dateStart: currentStart,
        dateEnd: currentEnd
      });

      commit('setInitialized', true);
    }
  },

  // Action para resetear fechas al mes actual
  resetToCurrentMonth({ commit }) {
    const currentStart = moment().startOf("month").format("YYYY-MM-DD");
    const currentEnd = moment().endOf("month").format("YYYY-MM-DD");

    commit('setDateRange', {
      dateStart: currentStart,
      dateEnd: currentEnd
    });

    commit('setRangeSelected', "4");
  }
};

const mutations = {
  setInvoiceSalesFilter(state, { key, value }) {
    if (state.invoiceSalesFilters.hasOwnProperty(key)) {
      state.invoiceSalesFilters[key] = value;
    }
  },
  setBusiness(state, newValue) {

    state.filters.business = newValue;
  },

  setLocation(state, newValue) {

    state.filters.location = newValue;
  },

  setDepartment(state, newValue) {

    state.filters.department_id = newValue;
  },

  setWarehouse(state, newValue) {
    state.filters.warehouse = newValue;
  },

  setProject(state, newValue) {
    state.filters.project = newValue;
  },

  setRangeSelected(state, newValue) {

    state.rangeSelected = newValue;
  },

  setDateStart(state, newValue) {

    if (newValue && moment(newValue).isValid()) {
      state.date = newValue;
      state.filters.dateStart = newValue;
    }
  },

  setDateEnd(state, newValue) {

    if (newValue && moment(newValue).isValid()) {
      state.date2 = newValue;
      state.filters.dateEnd = newValue;
    }
  },

  // Mutación principal para establecer rango de fechas
  setDateRange(state, payload) {


    if (payload.dateStart && moment(payload.dateStart).isValid()) {
      state.date = payload.dateStart;
      state.filters.dateStart = payload.dateStart;
    }

    if (payload.dateEnd && moment(payload.dateEnd).isValid()) {
      state.date2 = payload.dateEnd;
      state.filters.dateEnd = payload.dateEnd;
    }


  },

  // Mutación corregida para establecer valores
  setFilters(state, newFilters) {


    // Hacer merge de filtros existentes con nuevos
    const updatedFilters = { ...state.filters, ...newFilters };

    // Validar y establecer fechas si vienen en los filtros
    if (newFilters.dateStart && moment(newFilters.dateStart).isValid()) {
      state.date = newFilters.dateStart;
      updatedFilters.dateStart = newFilters.dateStart;
    }

    if (newFilters.dateEnd && moment(newFilters.dateEnd).isValid()) {
      state.date2 = newFilters.dateEnd;
      updatedFilters.dateEnd = newFilters.dateEnd;
    }

    state.filters = updatedFilters;


  },

  // Mutación para limpiar filtros
  clearFilters(state) {
    const currentStart = moment().startOf("month").format("YYYY-MM-DD");
    const currentEnd = moment().endOf("month").format("YYYY-MM-DD");

    state.filters = {
      business: null,
      location: null,
      warehouse: null,
      project: null,
      department_id: null,
      accountBank: null,
      payments_id: null,
      dateStart: currentStart,
      dateEnd: currentEnd,
      isNewOrder: false,
      isPackage: false,
      isDelivery: false
    };

    state.date = currentStart;
    state.date2 = currentEnd;
    state.rangeSelected = "4";
  },

  // Mutación para flag de inicialización
  setInitialized(state, value) {
    state._isInitialized = value;
  },

  // Mantener compatibilidad con código existente (DEPRECATED)
  setValues(state, filters) {

    this.commit('setFilters', filters);
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  // Considerar agregar namespaced: true para mayor organización
  // namespaced: true,
};